import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimal'
})
export class DecimalPipe implements PipeTransform {

  transform(value: number, digits: string = '1.0-2'): string {
    // You can apply custom decimal logic here if needed
    if (value === null || value === undefined) {
      return '';
    }
    // return value.toFixed(2);
    const roundedValue = Math.round(value * 100) / 100; // Round to 2 decimal places
    return roundedValue.toFixed(2);
  }

}
